/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
// import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";

const Sidebar = () => {
  const location = useLocation();
  // const pathname = location.pathname.split("/")[1];
  const pathname = location.pathname;

  // console.log("pageurl", pathname);
  const { user, userLoading } = useSelector((state) => state.user);


  const [sidebarData, setSidebarData] = useState(SidebarData); 
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);
  const [submenuDrop ,setSubmenudrop] = useState(false);
  const [permissions ,setPermissions] = useState([]);


  useEffect(()=> {

    if(user?.role){
      const permissionCodes = user?.role?.permissions?.map(item=> item.code) || [];
      setPermissions(permissionCodes);
    }


  },[user])

  const hasOrgChartAccess =
    permissions?.includes("org_chart") ||
    user?.modules?.some?.((m) => m.code === "org_chart");

  

  useEffect(() => {
    if (
      isMouseOverSidebar &&
      document.body.classList.contains("mini-sidebar")
    ) {
      document.body.classList.add("expand-menu");
      return;
    }
    document.body.classList.remove("expand-menu");
  }, [isMouseOverSidebar]);


  

  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };
  const { t } = useTranslation();


  const expandSubMenus = (menu) => {
    sessionStorage.setItem('menuValue', menu.menuValue);
    const updatedAdminSidebar = sidebarData.map((section) => {
      return { 
        ...section,
        showSubRoute: menu.menuValue == section.menuValue ? !menu.showSubRoute : false,
      };

      // console.log(updatedSection)

      // menu.menuValue != section.menuValue
      //     ? {
      //         ...updatedSection,
      //         showSubRoute: false,
      //       }
      //     : {
      //         ...updatedSection,
      //         showSubRoute: !menu.showSubRoute,
      //       },
     
      // return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const arrowDrop=()=>{
    setSubmenudrop(!submenuDrop);
  }

  return (
    <div
      className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
      id="sidebar"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="sidebar-inner slimscroll" style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
        <div id="sidebar-menu" className="sidebar-menu" style={{ height: "100%", display: "flex", flexDirection: "column" }}>  
          <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            <Scrollbars
              autoHide={false}
              autoHideTimeout={1000}
              autoHideDuration={200}
              style={{ height: "100%" }}
              thumbMinSize={30}
              universal={false}
              hideTracksWhenNotNeeded={true}
            >
              <ul className="sidebar-vertical" id="veritical-sidebar"> 
         
              {sidebarData.map((menu, menuIndex) => {
                // Visibility rules:
                //  - If the menu has its own `code`, gate on that code.
                //  - Otherwise, if it has submenus, show the parent only when at
                //    least one submenu is accessible (either no `code` or a
                //    matching permission). This prevents the parent from
                //    rendering when the user has no access to any child.
                //  - Otherwise, show always (legacy items with neither).
                const hasMenuCode = !!menu?.code;
                const hasSubMenus = Array.isArray(menu?.subMenus) && menu.subMenus.length > 0;
                const anyChildVisible = hasSubMenus
                  && menu.subMenus.some((s) => !s?.code || permissions?.includes(s?.code));
                const showMenu = hasMenuCode
                  ? permissions?.includes(menu.code)
                  : hasSubMenus ? anyChildVisible : true;
                if (showMenu) {
                  return (
                    <React.Fragment key={`menu-${menuIndex}-${menu.code}`}>
                      {/* <li className="menu-title" key={index + 1}>
  
                        <span>{t(mainTitle.tittle)}</span>
                        {mainTitle?.tittle === "CRM" ? (
                          <small class="newly-added-features">New</small>):("")
                        }
                      </li> */}
                     
                           
                            <React.Fragment key={`menu-content-${menuIndex}`}>
                              {menu.hasSubRoute === false ? (
                                <li key={menuIndex + 1}  className={pathname == menu.route ? "active" : ""}>
                                  <Link
                                    to={menu.route}
                                   
                                  >
                                    {/* {menu.icon} */}
                                    <i className={menu?.icon}/>
                                     <span>{t(menu.menuValue)}</span>
                                  </Link>
                                </li>
                              ) : (
                                <li className="submenu">
                                  <Link
                                    to="#"
                                    onClick={() => expandSubMenus(menu)}
                                    
                                    className={
                                      menu.showSubRoute  ? 'subdrop' : ''
                                    } 
                                  >
                                   
                                    <i className={menu?.icon}/>
                                    <span 
                                    // className={menu?.menuValue == "Employees" ? "noti-dot" : ""}
                                    >{t(menu.menuValue)}</span>
                                    <span className="menu-arrow">
                                    
                                    </span>
                                  </Link>
                                  <ul
                                    style={{
                                      display: menu.showSubRoute
                                        ? 'block'
                                        : 'none',
                                    }}
                                  >
                                    {menu.subMenus?.map(
                                      (
                                        subMenus,
                                        subMenu,
                                      ) => {
                                        const hasPermission = !subMenus?.code || permissions?.includes(subMenus?.code);
                                        if(hasPermission){
                                          return (
                                          
                                            <React.Fragment key={`submenu-${subMenu}-${subMenus.code}`}>
                                          
                                          {/* {console.log(subMenus?.showMenuRoute)} */}
                                          {subMenus?.showMenuRoute === true ? (
                                              <li key={subMenu + 1}>
                                                <Link
                                                  to={subMenus.route}
                                                
    
                                                  className={submenuDrop ? "subdrop":""}
                                                  onClick={arrowDrop}
                                                  
                                                >
                                                  {t(subMenus.menuValue)}
                                                  <span className="menu-arrow" ></span>
                                                </Link>
    
                                                <ul style={{display: submenuDrop ? "block":"none"}}>
                                                  {subMenus?.subMenusValues?.map((value,index)=>{
                                                    
                                                    return(
                                                <li key={index}>
                                                  <span>
                                                <Link to={value.route}><span>{t(value.menuValue)} </span></Link>
                                                </span>
                                                </li>)})
                                          }
                                          </ul>
                                                   </li>) :(
                                                                                          
                                                  <li key={subMenu + 1}>
                                                  <Link
                                                    to={subMenus.route}
                                                    
                                                    className={pathname== subMenus?.route ? "active" : ""}
                                                  >
                                                    {t(subMenus.menuValue)}
                                                  </Link>
                                                  
                                                  <ul>
                                                  {subMenus?.subMenusValues?.map((value,index)=>{
                                                    return(
                                                <li key={index}>
    
                                                <Link to={value.route} className={pathname== value?.route ? "active" : ""}
                                                    >{t(value.menuValue)}</Link>
                                                </li>)})
                                                }
                                                </ul>
                                                </li>
                                              )
    
                                        }
    
                                              
                                            </React.Fragment>
                                          );        
                                        }
                                        return null
                                        
                                      },
                                    )}
                                  </ul>
                                </li>
                              )}
                            </React.Fragment>
                          
                       
                    </React.Fragment>
                  );
                }
                return null;
                return <></>
               
              })}
            </ul>
            </Scrollbars>
          </div>
        </div>
      </div>

    


    </div>
  );
};

export default Sidebar;
